"use strict";

exports.__esModule = true;
exports.sortArrayOfStrings = sortArrayOfStrings;
function sortArrayOfStrings(arr) {
  return arr.sort(function (string1, string2) {
    var text1 = typeof string1 === "string" ? string1.toUpperCase() : string1;
    var text2 = typeof string2 === "string" ? string2.toUpperCase() : string2;
    var comparison = 0;
    if (text1 > text2) {
      comparison = 1;
    } else if (text1 < text2) {
      comparison = -1;
    }
    return comparison;
  });
}